import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import { AuthenticationProvider } from "./providers";
import { ReactFlowProvider } from "reactflow";
import { MessageBox } from "./Components/MessageBox/MessageBox";
import { HelmetProvider } from "react-helmet-async";
import { OutletContextProvider } from "./providers/OutletContext/OutletContext.provider";
import { ThemeProvider } from "@mui/material";
import { baseTheme } from "./Theme/ThemeVariable";
import { RolesProvider } from "./security/RolesProvider/RolesProvider";
import { SocketProvider } from "./providers";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <Provider store={store}>
          <ThemeProvider theme={baseTheme}>
            <AuthenticationProvider>
              <OutletContextProvider>
                <SocketProvider>
                  <RolesProvider>
                    <ReactFlowProvider>
                      <App />
                    </ReactFlowProvider>
                  </RolesProvider>
                </SocketProvider>
              </OutletContextProvider>
            </AuthenticationProvider>
            <MessageBox />
          </ThemeProvider>
        </Provider>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
